import type { UserRole } from '~/types/user'
import { FEATURES_OFF, disabledFeatureForPage } from '~/utils/featureFlags'
import { pageRedirect } from '~/utils/pageRoleFence'

export default defineNuxtRouteMiddleware(async (to, from) => {
    const user = await useAuthStore().setUser()
    if (!user) {
        return navigateTo('/login')
    }

    if (disabledFeatureForPage(to.path, user.features ?? FEATURES_OFF)) {
        return navigateTo('/')
    }

    const redirect = pageRedirect(user.role, to.path, (to.meta.roles as UserRole[]) || [])
    if (redirect) {
        return navigateTo(redirect)
    }
})
